import "./radialGauge.css";

const RadialGauge = ({ value, label, color, size = 96, strokeWidth = 8 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, value || 0));
  const offset = circumference - (clamped / 100) * circumference;
  const center = size / 2;

  return (
    <div className="radialGaugeWrap">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={center} cy={center} r={radius} fill="none" stroke="var(--profile-border)" strokeWidth={strokeWidth} />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${center} ${center})`}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" className="radialGaugeValue">
          {Math.round(clamped)}%
        </text>
      </svg>
      <div className="radialGaugeLabel">{label}</div>
    </div>
  );
};

export default RadialGauge;
